import { portalApi } from "@services/api/portalApi";

export const overviewPermission = "teacher-portal-overview.view";
export type RegisterCompletion = {
	staffId: number;
	initials: string;
	classId: number;
	classCode: string;
	subject: string;
	department: string;
	facultyCode: string;
	faculty: string;
	periodCount: number;
	markedCount: number;
};
export type UnmarkedRegister = {
	date: string;
	dayPeriod: number;
	staffId: number;
	initials: string;
	term: string;
	classId: number;
	classCode: string;
	subject: string;
	timeStart: string;
	department: string;
	facultyCode: string;
	faculty: string;
};
export type TeacherPortalOverview = {
	academicYearId: number;
	academicYear: string;
	registerPercentages: RegisterCompletion[];
	unmarkedRegisters: UnmarkedRegister[];
	updatedAt: string;
};
export async function fetchTeacherPortalOverview(signal?: AbortSignal) {
	return (
		await portalApi.get<TeacherPortalOverview>("/teacher-portal-overview", {
			signal,
		})
	).data;
}
